var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.584 6.658L23.24 1c4.96 4.805 8.033 11.48 8.033 18.86 0 7.434-3.119 14.153-8.142 18.965l-5.659-5.659c3.577-3.364 5.8-8.082 5.8-13.306 0-5.17-2.178-9.845-5.69-13.202zM10.022 20.5A5.489 5.489 0 008 16.24l5.323-5.323a12.957 12.957 0 013.699 9.082c0 3.517-1.397 6.708-3.666 9.048l-4.804-4.804a5.48 5.48 0 001.47-3.742z",
    fill: "currentColor"
  })));
}
export default SvgWebUp;